import {useQuery} from '@apollo/react-hooks';

import type {
    GetContactsSearchResults as GetContactsSearchResultsQuery,
    GetContactsSearchResultsVariables as GetContactsSearchResultsQueryVariables,
} from 'nutshell-graphql-types';

import GET_CONTACTS_SEARCH_RESULTS from '../queries/get-contacts-search-results.graphql';

export const useGetContacts = (
    query?: string | null
): {
    isLoading: boolean;
    contacts: any[];
    refetch: () => Promise<any>;
    fetchMore: (searchTerm?: string | null | undefined) => Promise<any>;
} => {
    const {data, loading, refetch, fetchMore} = useQuery<
        GetContactsSearchResultsQuery,
        GetContactsSearchResultsQueryVariables
    >(GET_CONTACTS_SEARCH_RESULTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            query,
            limit: 20,
        },
        notifyOnNetworkStatusChange: true,
    });

    const search = data ? data.search : null;
    const quickResults = search ? search.quickResults : null;

    const contactResults = quickResults ? quickResults.contactResults : [];

    return {
        contacts: contactResults,
        isLoading: loading,
        refetch,
        fetchMore: (searchTerm?: string | null) => {
            return fetchMore({
                query: GET_CONTACTS_SEARCH_RESULTS,
                variables: {
                    query: searchTerm,
                    limit: 20,
                },
                // @ts-expect-error
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;

                    return {
                        search: {
                            __typename: 'SearchResultItemConnection',
                            ...fetchMoreResult.search,
                        },
                    };
                },
            });
        },
    };
};
